// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { executeAwaitableHandlerChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import {
    chain,
    LoadRealTimeInventory,
} from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import { ProductDto, RealTimeInventoryModel } from "@insite/client-framework/Types/ApiModels";

export const XngLoadRealTimeInventory: any = async ({ result: { apiResult }, dispatch, getState, parameter }: any) => {
    if (!parameter.checkInventory) {
        return;
    }

    const products = apiResult.filter((p: any) => !!p) as ProductDto[];
    if (!products.length) {
        return;
    }

    const realTimeInventory = await executeAwaitableHandlerChain<
        Parameters<typeof loadRealTimeInventory>[0],
        RealTimeInventoryModel
    >(
        loadRealTimeInventory,
        {
            productIds: products.map(o => o.id),
            onComplete: realTimeInventoryProps => {
                if (realTimeInventoryProps.error) {
                    dispatch({
                        type: "Components/OrderUpload/SetFailedToLoadInventory",
                        parameter: { failedToLoadInventory: true },
                    });
                }
            },
        },
        { dispatch, getState },
    );

    realTimeInventory?.realTimeInventoryResults?.forEach(inventory => {
        products
            .filter(p => p.id === inventory.productId)
            .forEach(product => {
                product.qtyOnHand = inventory.qtyOnHand;

                const inventoryAvailability = inventory.inventoryAvailabilityDtos?.find(
                    o => o.unitOfMeasure === product.unitOfMeasure,
                );
                product.availability = inventoryAvailability?.availability || {
                    messageType: 0,
                    message: "",
                    requiresRealTimeInventory: false,
                };

                product.productUnitOfMeasures?.forEach(productUoM => {
                    const inventoryAvailability = inventory.inventoryAvailabilityDtos?.find(
                        o => o.unitOfMeasure === productUoM.unitOfMeasure,
                    );
                    productUoM.availability = inventoryAvailability?.availability || {
                        messageType: 0,
                        message: "",
                        requiresRealTimeInventory: false,
                    };
                });
            });
    });
};

replaceInChain(chain, LoadRealTimeInventory, XngLoadRealTimeInventory);
